import { axiosClient } from "./apiClient";

export function login(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/auth/admin-login', data)
}

export function logout(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/auth/admin-logout', data)
}

export function changePassword(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/settings/change-password', data)
}

export function forgotPassword(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/auth/admin-forgot-password', data)
}

export function verifyResetToken(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/auth/admin-verify-reset-token', data)
}

export function resetPassword(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/auth/admin-reset-password', data)
}

// ----------------------------------dashboard---------------------------------
export function dashboard(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/home/dashboard', data)
}

// ----------------------------------upload image---------------------------------
export function uploadImage(data) {
    return axiosClient.post('/tutor-match-ae/v1/upload/upload-image', data)
}

// ----------------------------------all lists---------------------------------
export function ageRangeListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/lists/age-range-list', data)
}

export function teachingInfoListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/lists/teaching-info-list', data)
}

export function emiratesListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/lists/emirates-list', data)
}

export function getCMSDetails(data) {
    return axiosClient.post('/tutor-match-ae/v1/lists/page_content', data)
}

// ----------------------------------parent---------------------------------
export function parentListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/parent/parents-list', data)
}

export function addParent(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/parent/add-parent', data)
}

export function editParent(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/parent/edit-parent', data)
}

export function viewParent(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/parent/view-parent', data)
}

export function deleteParent(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/parent/delete-parent', data)
}

export function blockUnblockParent(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/parent/block-unblock-parent', data)
}

// ----------------------------------tutor---------------------------------
export function tutorListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/tutor-list', data)
}

export function addTutor(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/add-tutor', data)
}

export function editTutor(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/edit-tutor', data)
}

export function viewTutor(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/view-tutor-details', data)
}

export function deleteTutor(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/delete-tutor', data)
}

export function blockUnblockTutor(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/block-unblock-tutor', data)
}

export function approveRejectTutor(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/tutor/approve-reject-tutor', data)
}

// ----------------------------------sub admin---------------------------------
export function subAdminListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/sub-admin-list', data)
}

export function addSubAdmin(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/add-sub-admin', data)
}

export function editSubAdmin(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/edit-sub-admin', data)
}

export function viewSubAdmin(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/view-sub-admin-detail', data)
}

export function addSubAdminPermission(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/add-sub-admin-permission', data)
}

export function editSubAdminPermission(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/edit-sub-admin-permission', data)
}

export function deleteSubAdmin(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/delete-sub-admin', data)
}

export function blockUnblockSubAdmin(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/block-unblock-sub-admin', data)
}

export function permissionModuleListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/sub-admin/permission-module-list', data)
}

// ----------------------------------booking---------------------------------
export function bookingListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/manage-bookings/view-all-bookings', data)
}

export function deleteBooking(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/manage-bookings/delete-booking', data)
}

export function viewBooking(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/manage-bookings/view-booking-details', data)
}

// ----------------------------------coupon code---------------------------------
export function couponCodeListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/coupon-code/coupon-code-list', data)
}

export function addCouponCode(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/coupon-code/add-coupon-code', data)
}

export function editCouponCode(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/coupon-code/edit-coupon-code', data)
}

export function viewCouponCode(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/coupon-code/view-coupon-code-detail', data)
}

export function deleteCouponCode(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/coupon-code/delete-coupon-code', data)
}

export function blockUnblockCouponCode(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/coupon-code/activate-deactivate-coupon-code', data)
}

// ----------------------------------subscription plan---------------------------------
export function subscriptionPlanListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/subscription/view-subscription-list', data)
}

export function addSubscriptionPlan(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/subscription/add-subscription-plan', data)
}

export function editSubscriptionPlan(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/subscription/edit-subscription-plan', data)
}

export function viewSubscriptionPlan(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/subscription/view-subscription-plan-detail', data)
}

export function deleteSubscriptionPlan(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/subscription/delete-subscription-plan', data)
}

export function blockUnblockSubscriptionPlan(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/subscription/activate-deactivate-subscription-plan', data)
}

// ----------------------------------badge---------------------------------
export function badgeListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/badge/view-badge-list', data)
}

export function addBadge(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/badge/add-badge', data)
}

export function editBadge(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/badge/edit-badge', data)
}

export function viewBadge(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/badge/view-badge-detail', data)
}

export function deleteBadge(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/badge/delete-badge', data)
}

export function blockUnblockBadge(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/badge/activate-deactivate-badge', data)
}

// ----------------------------------notification---------------------------------
export function notificationListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/notification/notification-list', data)
}

export function notificationOptions(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/notification/notification-options', data)
}

export function sendNotification(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/notification/send-notification', data)
}

export function viewNotification(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/notification/view-notification-detail', data)
}

// ----------------------------------reported bookings---------------------------------
export function reportedBookingsListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/manage-reported-bookings/reported-booking-list', data)
}

export function viewReportedBooking(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/manage-reported-bookings/reported-booking-details', data)
}

export function changeReportedBookingStatus(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/manage-reported-bookings/change-report-status', data)
}

// ----------------------------------review---------------------------------
export function reviewListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/review/view-tutor-review-list', data)
}

export function viewReview(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/review/view-review-details', data)
}

export function viewReviewSummary(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/review/view-rating-summary', data)
}

// ----------------------------------cms---------------------------------
export function cmsPageDetails(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/get-cms-page', data)
}

export function addCmsPage(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/add-cms', data)
}

export function editCmsPage(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/edit-cms', data)
}

export function contactUsListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/contact-us', data)
}

// ----------------------------------faq---------------------------------
export function faqListing(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/faq-list', data)
}

export function addFaq(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/add-faq', data)
}

export function editFaq(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/edit-faq', data)
}

export function viewFaq(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/view-faq', data)
}

export function deleteFaq(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/delete-faq', data)
}

export function blockUnblockFaq(data) {
    return axiosClient.post('/tutor-match-ae/v1/admin/cms/block-unblock-faq', data)
}